import { Button, Col, Row } from 'antd';
import { DeviceMap, ExpandMap, kiraB50Thumbnail } from 'assets/images';
import PropType from 'prop-types';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { formatDate, formatTime } from 'util/date';
import { getMachineType } from 'util/machine-type';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';
import { fetchCleaningReportsRouteImage } from '../CleaningReportList/state/operation';

export const CleaningReportExpandable = ({ rowData }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACES.CLEANING_REPORT);
  const dispatch = useDispatch();
  const { machine, startDate, endDate, machineFacility } = rowData;

  const renderCleaningReportCol = (title, value) => (
    <Col className="cleaningReport-expandable-col" span={4}>
      <h5>{title}</h5>
      <span>{value}</span>
    </Col>
  );

  const renderMachineImage = (value) => (
    <Col span={4}>
      <img width={50} src={value} alt="icon" />
    </Col>
  );

  const openRouteImage = useCallback(() => {
    const formattedDate = formatDate(rowData.endDate, {
      shortFormat: true
    });
    const machineType = getMachineType(machine?.materialNumber);
    const machineAlias = rowData.machineAlias || '';
    const cleaningRouteText = t('routeImageModal.cleaningRoute');

    dispatch(
      fetchCleaningReportsRouteImage({
        id: rowData.id,
        title: `${machineType} / ${machineAlias} - ${cleaningRouteText} ${formattedDate}`
      })
    );
  }, [
    dispatch,
    machine?.materialNumber,
    rowData.endDate,
    rowData.id,
    rowData.machineAlias,
    t
  ]);

  return (
    <div className="cleaningReport-expandable">
      <Row>
        {renderMachineImage(machine?.thumbnail || kiraB50Thumbnail)}
        {renderCleaningReportCol(
          t('cleaningReportTable.columns.materialSerialNumber'),
          `${machine?.materialNumber} / ${machine?.serialNumber}`
        )}
        {renderCleaningReportCol(
          t('cleaningReportTable.columns.facility'),
          machineFacility
        )}
        {renderCleaningReportCol(
          t('cleaningReportTable.columns.startTime'),
          formatTime(startDate)
        )}
        {renderCleaningReportCol(
          t('cleaningReportTable.columns.endTime'),
          formatTime(endDate)
        )}
        <Col className="cleaningReport-expandable-col" span={4}>
          <Button
            className="route-image-button"
            onClick={openRouteImage}
            type="link">
            <DeviceMap className="download-icon" />
            <ExpandMap className="expand-icon" />
          </Button>
        </Col>
      </Row>
    </div>
  );
};

CleaningReportExpandable.propTypes = {
  rowData: PropType.objectOf(
    PropType.oneOfType([PropType.object, PropType.number, PropType.string])
  ).isRequired
};

export default CleaningReportExpandable;
